import { CleaningServices, Search } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GroupsIcon from '@mui/icons-material/Groups';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import { Typography } from '@mui/material';
import { GrGroup } from 'react-icons/gr';
import { HiDocumentReport } from 'react-icons/hi';
import { useNavigate } from 'react-router';
import Select from 'react-select';
import { PermissionData } from '../../../context/Component/PermissionData';
import { categoriasPorcentajeEvaluacionDes } from '../../../utils/enums/categoriasPorcentajeEvaluacionDes';
import { grupoOcupacionalesEnum } from '../../../utils/enums/grupoOcupacionalesEnum';

export const BarraOpciones = ({
  openModalCrear,
  openModalNotificacion,
  updateFilter,
  filtroState = {},
  estadoPeriodo,
  route,
  hidden = false,
  supervisor = false,
  getReportPerGroup,
  listaAreasState = [],
  supervisoresListState = [],
  cleanfilter,
  setRefreshListState,
}) => {
  // * PERMISOS DEL USUARIO.
  const permisosState = PermissionData();

  // ? HOOK-NAVIGATE
  const navigate = useNavigate();

  // * ESTILOS DE LOS ICONOS.
  const iconStyle = {
    marginTop: -0.5,
    marginRight: 0.5,
  };

  const handleKeyDown = (e) => {
    if (event.key === 'Enter') {
      e.preventDefault();
      updateFilter('nombreEmpleado', e.target.value);
      setRefreshListState(true);
    }
  };

  return (
    <div>
      <div className="row border m-1 p-2" hidden={supervisor}>
        <div className="col-md ps-2 container d-flex justify-content-start">
          <button type="button" hidden={supervisor} className="btn btn-primary-mem me-2" onClick={() => navigate(route)}>
            <ArrowBackIcon sx={iconStyle} />
            Volver
          </button>

          {estadoPeriodo !== 1 && permisosState.ROLE_ADMIN_EVALUACIONES | permisosState.ROLE_ADMIN ? (
            <>
              <button type="button" hidden={hidden || supervisor} className="btn btn-primary me-2" onClick={() => openModalCrear()}>
                <AddIcon sx={iconStyle} /> Crear Evaluacion
              </button>

              <div className="btn-group" hidden={hidden || supervisor}>
                <button type="button" className="btn btn-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <NotificationImportantIcon sx={iconStyle} /> Notificar Evaluadores
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button type="button" className="dropdown-item" onClick={() => openModalNotificacion(1)}>
                      <SensorOccupiedIcon sx={iconStyle} />
                      Notificación única
                    </button>
                  </li>

                  <li>
                    <button type="button" className="dropdown-item" onClick={() => openModalNotificacion(2)}>
                      <GroupsIcon sx={iconStyle} />
                      Notificar a todos los evaluadores
                    </button>
                  </li>
                </ul>
              </div>

              <div className="btn-group ms-2" hidden={hidden || supervisor}>
                <button type="button" className="btn btn-orange dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <HiDocumentReport fontSize={23} /> Reportes por Grupo
                </button>
                <ul className="dropdown-menu">
                  {Object.keys(grupoOcupacionalesEnum).length > 0 &&
                    Object.entries(grupoOcupacionalesEnum).map(([clave, valor]) => (
                      <li key={clave}>
                        <button type="button" className="dropdown-item" onClick={() => getReportPerGroup(valor)}>
                          <GrGroup fontSize={22} /> Grupo #{valor}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

      {!hidden ? (
        <div className="row border m-1 p-2">
          <div className="col-2">
            <Typography fontSize="12px" fontWeight="bold">
              Área Organizacional
            </Typography>
            <Select
              id="select-area"
              classNamePrefix="select"
              isSearchable={true}
              placeholder="Seleccionar Área"
              options={listaAreasState}
              getOptionLabel={(option) => option.nombre}
              getOptionValue={(option) => option.id}
              onChange={(e) => updateFilter('areaId', e.id)}
              value={listaAreasState.find((x) => x.id === filtroState.areaId)}
            />
          </div>
          <div className={'col-3'}>
            <Typography fontSize="12px" fontWeight="bold">
              Evaluador
            </Typography>
            <Select
              id="select-evaluador"
              classNamePrefix="select"
              isSearchable={true}
              placeholder="Seleccionar Evaluador"
              options={supervisoresListState}
              getOptionLabel={(option) => option.nombreLabel}
              getOptionValue={(option) => option.id}
              onChange={(e) => updateFilter('evaluadorId', e.id)}
              value={supervisoresListState.find((x) => x.id === filtroState.evaluadorId)}
            />
          </div>
          <div className={'col-3'}>
            <Typography fontSize="12px" fontWeight="bold">
              Categorías
            </Typography>
            <Select
              id="select-evaluador"
              classNamePrefix="select"
              isSearchable={true}
              placeholder="Seleccionar Evaluador"
              options={categoriasPorcentajeEvaluacionDes}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.id}
              onChange={(e) => updateFilter('porcentaje', e)}
              value={categoriasPorcentajeEvaluacionDes.find((x) => x.id === filtroState?.porcentaje?.id ?? 0)}
            />
          </div>
          <div className="col-3" hidden={hidden}>
            <Typography fontSize="12px" fontWeight="bold">
              Empleado
            </Typography>
            <div className="input-group mb-2">
              <input
                className="form-control w-75"
                value={filtroState.nombreEmpleado}
                onChange={(e) => {
                  e.preventDefault();
                  updateFilter('nombreEmpleado', e.target.value);
                }}
                onKeyDown={handleKeyDown}
                type="text"
              />

              <button
                onClick={() => setRefreshListState(true)}
                className="btn btn-primary-mem"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Buscar Empleado"
                type="button"
              >
                <Search />
              </button>
            </div>
          </div>

          <div className="col-1">
            <button
              style={{ marginTop: 19 }}
              id="btn-clean-empleados"
              className="btn btn-danger"
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Limpiar filtros"
              onClick={() => {
                cleanfilter();
              }}
            >
              <CleaningServices />
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
